export default __webpack_public_path__ + "static/media/27.a694996d.jpg";